import { Monitor, Moon, Sun } from "lucide-react";
import { type ThemeChoice, useTheme } from "@/lib/theme";
import { Segmented } from "./ui";

const OPTIONS: { value: ThemeChoice; label: React.ReactNode; title: string }[] = [
  {
    value: "light",
    title: "Day",
    label: (
      <>
        <Sun className="size-4" aria-hidden />
        Day
      </>
    ),
  },
  {
    value: "dark",
    title: "Night",
    label: (
      <>
        <Moon className="size-4" aria-hidden />
        Night
      </>
    ),
  },
  {
    value: "system",
    title: "Same as this device",
    label: (
      <>
        <Monitor className="size-4" aria-hidden />
        Same as this device
      </>
    ),
  },
];

/** Settings control: day, night, or follow the device. */
export function ThemeSetting() {
  const { choice, setChoice } = useTheme();
  return <Segmented value={choice} onChange={setChoice} options={OPTIONS} className="max-w-full flex-wrap" />;
}
